import { render, staticRenderFns } from "./DosboxDownloadCard.vue?vue&type=template&id=ab5dca44&scoped=true&"
import script from "./DosboxDownloadCard.vue?vue&type=script&lang=js&"
export * from "./DosboxDownloadCard.vue?vue&type=script&lang=js&"
import style0 from "./DosboxDownloadCard.vue?vue&type=style&index=0&id=ab5dca44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5dca44",
  null
  
)

export default component.exports